import {ChangeDetectorRef, Component, Input, OnChanges} from '@angular/core';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss']
})
export class TagComponent implements OnChanges {

  @Input() color: string = '';
  @Input() clickable = false;
  @Input() tagSelect = false;

  private textColors = [
    { background: '#CDF9F3', textColor: '#118C7B' },
    { background: '#D4DAF3', textColor: '#465DBE' },
    { background: '#CEEEAA', textColor: '#64952D' },
    { background: '#FBC5FF', textColor: '#B916C5' },
    { background: '#FED5C9', textColor: '#9B3F24' },
    { background: '#DDBFE5', textColor: '#723A81' },
    { background: '#FFE0B2', textColor: '#8F6322' },
    { background: '#B2E5FD', textColor: '#286E8F' },
    { background: '#EFC89C', textColor: '#795731' },
    { background: '#E4E7EB', textColor: '#4F5A6A' },
    { background: '#FACDD2', textColor: '#D02A3D' },
    { background: '#D7CDC8', textColor: '#7B665C' }
  ];

  protected textColor = '';

  constructor(private change: ChangeDetectorRef) {
  }

  ngOnChanges(){
    this.textColor = this.textColors.find(c => c.background == this.color?.toUpperCase())?.textColor || '#132939CF';
    this.change.markForCheck();
  }
}
